export default __webpack_public_path__ + "static/media/bw_photos_woodstock-1.94bb326b.jpg";